import React from 'react';
export var reactUIFeatureFlagsDefault = {
  dateInputFixSameNumberTypingOnRefocus: false,
  dateInputAllowInvalidValuesInDays: false,
  comboBoxAllowValueChangeInEditingState: false,
  stickyReduceLayoutEvents: false,
  radioGroupRemoveBaselineSpacer: false,
  groupAddHintAndTooltipSupport: false,
  popupFixPinTearing: false,
  autocompleteUseMaskedInput: false,
  fxInputUseMaskedInput: false,
  sidePageDisableHeaderShrink: false,
  sidePageNotCutTitleOnStuckByDefault: false,
  tokenInputCreateTokenOnBlurInWithoutReferenceMode: false,
  textareaBaselineAlign: false
};
export var ReactUIFeatureFlagsContext = /*#__PURE__*/React.createContext(reactUIFeatureFlagsDefault);
ReactUIFeatureFlagsContext.displayName = 'ReactUIFeatureFlagsContext';
ReactUIFeatureFlagsContext.__KONTUR_REACT_UI__ = 'ReactUIFeatureFlagsContext';